import Catalyst from '@Services/Catalyst';

export const QUICK_SEARCH_TRACKING_BUTTON_TYPES = {
  learnHowItWorks: 'rx2:homepage:ai-banner:learn-how-it-works',
  drawButton: 'rx2:homepage:draw-button',
  integratedDatabases: 'rx2:homepage:integrated-databases',
};

export const trackQuickSearchButtonClick = (buttonType) => {
  Catalyst.trackEvent('buttonClick', {
    buttonType,
  });
};
